import { Field, useFormikContext } from "formik";

import { Button, Heading } from "@icg360/design-system";

import {
  RadioButtonField,
  RadioButtonGroup,
} from "components/shared/form-fields";
import { type EnrollmentStep } from "pages/payment-plan-update/easypay-enroll-form";
import { type EasyPayFormValues } from "pages/payment-plan-update/payment-plan-update";
import { useFlags } from "utils";

import styles from "./choose-day.module.scss";

type ChooseDayProps = {
  setStep: (step: EnrollmentStep) => void;
};

export const ChooseDay = ({ setStep }: ChooseDayProps) => {
  const { easyPayFullPayOnly } = useFlags();
  const { values, setFieldValue } = useFormikContext<EasyPayFormValues>();

  return (
    <div className={styles.cardBody}>
      <Heading size="lg">Choose a payment processing day</Heading>
      <p>
        We&apos;ll email your next payment date and amount when you finish
        signing up.
      </p>

      <Field
        id="draftDate"
        component={RadioButtonGroup}
        onChange={(value) => {
          setFieldValue("draftDate", value);
        }}
        value={values.draftDate}
        fieldChildren={() => (
          <>
            <Field
              value="1stMonth"
              label="1st of the month"
              component={RadioButtonField}
            />
            <Field
              value="8thMonth"
              label="8th of the month"
              component={RadioButtonField}
            />
            <Field
              value="15thMonth"
              label="15th of the month"
              component={RadioButtonField}
            />
            <Field
              value="22ndMonth"
              label="22nd of the month"
              component={RadioButtonField}
            />
          </>
        )}
      />

      <div className={styles.navigation}>
        <Button
          appearance="tertiary"
          onPress={() => setStep(easyPayFullPayOnly ? "welcome" : "choosePlan")}
          data-testid="easypay-day-back-btn"
        >
          Go back
        </Button>
        <Button
          onPress={() => setStep("chooseMethod")}
          data-testid="easypay-day-continue-btn"
          disabled={!values.draftDate}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
